// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_22XxiMUHNS2v7FVwRtoY60"};